namespace GeniuzPOS.Member {
    export class PsMemberColumns {
        static columnsKey = 'Member.PsMember';
    }
}
